(() => {
  const disclosures = document.querySelectorAll('.engraving__disclosure');
  for (const disclosure of disclosures) {
    const input = disclosure.querySelector('[data-engraving-input]');
    const submit = disclosure.querySelector('[data-engraving-submit]');
    const uppercaseRadio = disclosure.querySelector("input[data-type='uppercase']");
    const caseRadios = disclosure.querySelectorAll('.engraving-text-case input[type="radio"]');
    if (!input || !submit) continue;

    const baseDisabled = submit.hasAttribute('disabled');

    const updateDisabled = () => {
      const empty = !input.value || input.value.trim().length === 0;
      submit.toggleAttribute('disabled', baseDisabled || empty);
    };

    const isUppercase = () => Boolean(uppercaseRadio?.checked);

    const enforceCase = () => {
      if (!isUppercase()) return;
      const start = input.selectionStart;
      const end = input.selectionEnd;
      const newVal = input.value.toUpperCase();
      if (newVal !== input.value) {
        input.value = newVal;
        if (start != null && end != null) input.setSelectionRange(start, end);
      }
    };

    input.addEventListener('input', () => {
      enforceCase();
      updateDisabled();
    });
    disclosure.addEventListener('toggle', updateDisabled);

    for (const radio of caseRadios) {
      radio.addEventListener('change', () => {
        enforceCase();
      });
    }

    // Initial state sync
    enforceCase();
    updateDisabled();
  }
})();
